import { apiClient } from './api';
import type { ApiResponse, AnalyticsOverview, MessageMetrics, QueueStatus } from '@/types';

export type AnalyticsRange = 'today' | '7d' | '30d';
export type AnalyticsChannel = 'all' | 'whatsapp' | 'webchat';

export interface AnalyticsMessage {
  id: string;
  event_type: string;
  status: string;
  created_at: string;
  recipient_phone?: string;
  template_key?: string;
  attempts?: number;
  max_attempts?: number;
}

export interface GetAnalyticsParams {
  range: AnalyticsRange;
  channel: AnalyticsChannel;
}

export async function getAnalyticsOverview(params: GetAnalyticsParams): Promise<ApiResponse<AnalyticsOverview>> {
  return apiClient.get<AnalyticsOverview>('/analytics/overview', params);
}

export async function getMessageMetrics(params: GetAnalyticsParams): Promise<ApiResponse<MessageMetrics>> {
  return apiClient.get<MessageMetrics>('/analytics/messages', params);
}

export async function getQueueStatus(): Promise<ApiResponse<QueueStatus>> {
  return apiClient.get<QueueStatus>('/analytics/queue');
}

export async function getAnalyticsMessages(params: GetAnalyticsParams): Promise<ApiResponse<AnalyticsMessage[]>> {
  return apiClient.get<AnalyticsMessage[]>('/analytics/messages', params);
}
